import "./Skills.css";
import { FaHtml5, FaCss3, FaReact, FaGitAlt, FaTerminal } from "react-icons/fa";
import { RiNodejsLine } from "react-icons/ri";
import { SiTypescript, SiFramer } from "react-icons/si";
import { TbJson, TbApi } from "react-icons/tb";
import { DiResponsive } from "react-icons/di";
import { MdStyle } from "react-icons/md";
import { VscGitFetch } from "react-icons/vsc";
import { SiReactrouter, SiRedux } from "react-icons/si";
import { GoCopilot } from "react-icons/go";

export default function Skills() {
  const skillsData = [
    { name: "HTML5", icon: <FaHtml5 /> },
    { name: "CSS", icon: <FaCss3 /> },
    { name: "Responsive design", icon: <DiResponsive /> },
    { name: "JavaScript (ES6+)", icon: <RiNodejsLine /> },
    { name: "React.js", icon: <FaReact /> },
    { name: "Git & GitHub", icon: <FaGitAlt /> },
    { name: "JSON data handling", icon: <TbJson /> },
    { name: "API integration", icon: <TbApi /> },
    { name: "UI: Tailwind CSS, MUI & Related", icon: <MdStyle /> },
    {
      name: "AI-Assisted Development Tools (Cursor, GitHub Copilot)",
      icon: <GoCopilot />,
    },
    { name: "Terminal Commands & Cli", icon: <FaTerminal /> },
    { name: "TypeScript", icon: <SiTypescript /> }, // رقم 13
    { name: "Data Fetching: TanStack Query, Axios", icon: <VscGitFetch /> },
    { name: "Routing: React Router", icon: <SiReactrouter /> },
    {
      name: "Redux Toolkit",
      icon: <SiRedux />,
    },
    { name: "Animation: Framer Motion", icon: <SiFramer /> },
  ];

  const mid = Math.ceil(skillsData.length / 2);
  const firstColumn = skillsData.slice(0, mid);
  const secondColumn = skillsData.slice(mid);

  // دالة صغيرة تحدد إذا كان الـ index من 0 إلى 11 (أول 12) ياخد كلاس gold
  const getSkillNameClass = (globalIndex) => {
    return globalIndex < 10 ? "skill-name gold-text" : "skill-name";
  };

  return (
    <div className="skills-container" id="skills">
      <h1>
        My <span>Skills</span>
      </h1>

      <div className="skills-child">
        {/* العمود الأول */}
        <div className="sort"></div>
        <div className="skills-list">
          <div className="skills-grandson">
            <ul>
              {firstColumn.map((skill, index) => (
                <li key={index}>
                  <span className="skill-icon">{skill.icon}</span>
                  <span className={getSkillNameClass(index)}>{skill.name}</span>
                </li>
              ))}
            </ul>
          </div>
          {/* العمود الثاني */}
          <div className="skills-grandson">
            <ul>
              {secondColumn.map((skill, index) => {
                const globalIndex = mid + index; // الـ index الحقيقي في المصفوفة كلها
                return (
                  <li key={globalIndex}>
                    <span className="skill-icon">{skill.icon}</span>
                    <span className={getSkillNameClass(globalIndex)}>
                      {skill.name}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
